//  SideBar.js
//
//  Updated 3/4.
//
//  Abstract: Side bar (drawer) component.

//	React
import React, { useState, useEffect } from 'react';
import { Switch, Link, NavLink, Route } from 'react-router-dom';
//	Material-ui styles
import {
	makeStyles,
	CssBaseline,
	Hidden,
	useTheme,
	Button,
	List,
	ListItem,
	ListItemText,
	Typography,
	Drawer,
	IconButton,
	ListItemIcon
} from '@material-ui/core';
import CreateIcon from '@material-ui/icons/Create';
import DoneIcon from '@material-ui/icons/Done';
import HomeIcon from '@material-ui/icons/Home';
import NotesIcon from '@material-ui/icons/Notes';

//	Sidebar width
const drawerWidth = 240;

//	CSS styles`
const useStyles = makeStyles((theme) => ({
	root: {
		display: 'flex',
	},
	drawer: {
		[theme.breakpoints.up('sm')]: {
			width: drawerWidth,
			flexShrink: 0,
		},
	},
	menuButton: {
		marginRight: theme.spacing(2),
		[theme.breakpoints.up('sm')]: {
			display: 'none',
		},
	},
	drawerPaper: {
		width: drawerWidth,
	},
	ListItem: {
		fontSize: 14,
	},
	activeLink: {
		color: 'blue'
	},
	title: {
		justify: 'center',
		paddingLeft: '10%',
		paddingTop: '10%',
		paddingBottom: '10%',
	},
	subtitle: {
		display: 'inline'
	},
	drawerLinks: {
		color: 'black',
	},
}));

export default function SideBar(props) {

	const { window } = props;
	const classes = useStyles();
	const theme = useTheme();
	const [isMobileOpen, setIsMobileOpen] = useState(false);


	const handleDrawerToggle = () => {
		setIsMobileOpen(!isMobileOpen);
	};

	//	Define responsive drawer container and content
	const drawerContainer = window !== undefined ? () => window().document.body : undefined;
	const drawerContent = (
		<div>
			<div className={classes.toolbar} />
			<Typography className={classes.title} style={{ display: 'inline-block' }}>
				AllergI
			</Typography>
			<Typography variant="p" className={classes.subtitle} style={{ display: 'inline-block' }}>
				_      Build v0.0.1
			</Typography>
			<List className={classes.list}>
				<NavLink exact className={classes.drawerLinks} activeClassName={classes.activeLink} to='/'>
					<ListItem button key="home">
						<ListItemIcon>
							{' '}
							<HomeIcon />{' '}
						</ListItemIcon>
						<ListItemText variant={'p'} primary="Overview" classes={{ primary: classes.ListItem }} />
					</ListItem>
				</NavLink>

				<NavLink className={classes.drawerLinks} activeClassName={classes.activeLink} to='/create'>
					<ListItem button key="CreateTests">
						<ListItemIcon>
							{' '}
							<CreateIcon />{' '}
						</ListItemIcon>
						<ListItemText primary="Create Tests" classes={{ primary: classes.ListItem }} />
					</ListItem>
				</NavLink>

				<NavLink className={classes.drawerLinks} activeClassName={classes.activeLink} to='/view'>
					<ListItem button key="viewTests">
						<ListItemIcon>
							{' '}
							<NotesIcon />{' '}
						</ListItemIcon>
						<ListItemText primary="View Tests" classes={{ primary: classes.ListItem }} />
					</ListItem>
				</NavLink>
				<NavLink className={classes.drawerLinks} activeClassName={classes.activeLink} to='/review'>
					<ListItem button key="ReviewCompletedTests">
						<ListItemIcon>
							{' '}
							<DoneIcon />{' '}
						</ListItemIcon>
						<ListItemText primary="Review Results" classes={{ primary: classes.ListItem }} />
					</ListItem>
				</NavLink>
			</List>
		</div>
	);

	return (
		<>
			<div className={classes.root}>
				<CssBaseline />
				<nav className={classes.drawer} aria-label="mailbox folders">
					<Hidden smUp implementation="css">
						<Drawer
							container={drawerContainer}
							variant="temporary"
							anchor={theme.direction === 'rtl' ? 'right' : 'left'}
							open={isMobileOpen}
							onClose={handleDrawerToggle}
							classes={{
								paper: classes.drawerPaper,
							}}
							ModalProps={{
								keepMounted: true,
							}}
						>
							{drawerContent}
						</Drawer>
					</Hidden>
					<Hidden xsDown implementation="css">
						<Drawer
							classes={{
								paper: classes.drawerPaper,
							}}
							variant="permanent"
							open
						>
							{drawerContent}
						</Drawer>

					</Hidden>
				</nav>
			</div>
		</>
	);
}
